define('components/course/models/slide-type/zeus-base',[
    "components/course/models/slide-type/base"
], function(Base) {
    "use strict";

    return Base.extend({
        "saveStateJSONKey": function() {
            return {
                "data": {
                    "saveState": null
                }
            };
        },

        "getTranscript": function() {
            var globalComponentData = (
                this.get('data') || {}
            ).globalComponentData || {};

            return globalComponentData.audioScriptText || null;
        }
    });
});

